module.exports = __webpack_public_path__ + "img/APP_HP_Kr_mb.c959369c.jpg";